import { lazy } from 'react'

// pdf.js is heavy (~400KB), so the viewer loads only once a page is first shown.
export const LazyPdfViewer = lazy(() => import('./PdfViewer'))
